exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n* {\n  padding: 0;\n  margin: 0;\n}\nbody,\nhtml {\n  padding: 0;\n  margin: 0;\n}\n#app {\n  font-family: \"Noto Sans Sc\";\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n", ""]);

// exports
